module.exports = __webpack_public_path__ + "img/clear.5937fadd.svg";